<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <!-- <div *ngIf="data$ | async as pipelines"> -->
        <div style="page-break-inside: avoid">
            <h5>{{ title }}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td>Material</td>
                    <td>Terrain</td>
                    <td style="text-align:right;padding-right:5px;">Length (km)</td>
                    <td style="text-align:right;padding-right:5px;">Diameter (inch)</td>
                    <td style="text-align:right;padding-right:5px;">Daily Capacity</td>
                    <td style="text-align:right;padding-right:5px;">Annual Capacity</td>
                </tr>
                <tr *ngFor="let pl of pipelines">
                    <td [innerHTML]="pl.fluidType | highlight: searchTerm"></td>
                    <td>
                        <span *ngIf="pl.isOnshore">onshore</span>
                        <span *ngIf="pl.isOnshore && pl.isOffshore"> and </span>
                        <span *ngIf="pl.isOffshore">offshore</span>
                    </td>
                    <td style="text-align: right; padding-right: 5px;">
                        <span *ngIf="pl.length">{{ pl.length }}</span>
                    </td>
                    <td style="text-align: right; padding-right: 5px;">
                        <span *ngIf="pl.diameter">{{ pl.diameter }}</span>
                    </td>
                    <td style="text-align: right; padding-right: 5px;">
                        <span *ngIf="pl.dailyCapacity">{{ pl.dailyCapacity | number }}&nbsp;{{ pl.dailyRateUnit
                            }}</span>
                    </td>
                    <td style="text-align: right; padding-right: 5px;">
                        <span *ngIf="pl.annualCapacity">{{ pl.annualCapacity | number }}&nbsp;{{ pl.annualRateUnit
                            }}</span>
                    </td>
                </tr>
            </table>
        </div>
    <!-- </div> -->
</ng-template>

<ng-template #template_mobile let-title="title">
    <!-- <div *ngIf="data$ | async as pipelines"> -->
        <div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
            <div *ngFor="let pl of pipelines" class="optionalComponentSectionTable">
                <div>
                    <span style="font-weight:bold">Material: </span>
                    <span [innerHTML]="pl.fluidType | highlight: searchTerm"></span>
                </div>
                <div *ngIf="pl.isOnshore || pl.isOffshore">
                    <span style="font-weight:bold">Terrain: </span>
                    <span *ngIf="pl.isOnshore">onshore</span>
                    <span *ngIf="pl.isOnshore && pl.isOffshore"> and </span>
                    <span *ngIf="pl.isOffshore">offshore</span>
                </div>
                <div *ngIf="pl.length">
                    <span style="font-weight:bold">Length (km): </span>
                    <span>{{ pl.length }}</span>
                </div>
                <div *ngIf="pl.diameter">
                    <span style="font-weight:bold">Diameter (inch): </span>
                    <span>{{ pl.diameter }}</span>
                </div>
                <div *ngIf="pl.dailyCapacity">
                    <span style="font-weight:bold">Daily Capacity: </span>
                    <span>{{ pl.dailyCapacity | number }}&nbsp;{{ pl.dailyRateUnit }}</span>
                </div>
                <div *ngIf="pl.annualCapacity">
                    <span style="font-weight:bold">Annual Capacity: </span>
                    <span>{{ pl.annualCapacity | number }}&nbsp;{{ pl.annualRateUnit }}</span>
                </div>
            </div>
        </div>
    <!-- </div> -->
</ng-template>